import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "Sales CRM",
    description: "Company pipeline for the sales team. Track accounts, owners, pipeline value and win probability in one place.",
    url: getOrigin()
}
